export default __webpack_public_path__ + "static/media/marin4.26336fa5.jpg";